import { type PropsWithChildren } from 'react';
import { classNames } from '@utils/classNames.ts';

export function Heading4({
  id,
  children,
  className,
  ...rest
}: PropsWithChildren<{ id?: string; className?: string }>) {
  return (
    <h1
      id={id}
      className={classNames(
        'text-base tracking-normal font-medium lg:text-2xl text-slate-900',
        className,
      )}
      {...rest}
    >
      {children}
    </h1>
  );
}
